module.exports = __webpack_public_path__ + "img/William Rudolf Lobkowicz.29fda588.jpg";